<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{
                $t('SeaExport.InviteToChecktheBL')
              }}
              </el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_M/HBL_identification'])" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{
                $t('SeaExport.CheckingHistory')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-checkbox
            v-model="form.edi"
            no="3"
            :disabled="readonly"
            style="margin-left: 10px;"
          >EDI</el-checkbox>
          <el-checkbox v-model="form.oversea" no="4" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="5"
            style="margin-left: -20px"
            :disabled="readonly"
            @change="pm.chargeEsaeq()"
          >Part of</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="6"
            style="margin-left: -20px"
            :disabled="readonly"
            @change="pm.changeContainer()"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
        </div>
      </div>
    </div>
    <tab-MBL2-UICustom-layout :element-blocks="elementBlocks">
      <template v-if="!form.showDetail">
        <el-form-item slot="detailFormat" style="display: flex; justify-content: flex-end;margin-top: -24px;">
          <el-button no="DetailFormat" :disabled="readonly" type="primary" @click="formatChange(true)">{{ $t('CargoMsg.Cargo_DetailFormat') }} </el-button>
        </el-form-item>
        <el-button no="DetailFormat" :disabled="readonly" style="margin-left: 155px" type="primary" @click="formatChange(true)">{{ $t('CargoMsg.Cargo_DetailFormat') }} </el-button>
        <template v-if="elementDict.shipper.viewable" slot="shipper">
          <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width" :class="variableCss.shipperCode">
            <template slot="label">
              <line-label :class="(elementDict.shipper.isRequire ? 'blue ' : ' ') + variableCss.shipperLine" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="7"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="8"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
              />
              <el-button no="9" type="primary" :disabled="readonly || !elementDict.shipper.writable" style="margin-left: 5px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            :class="'auto-width ' + getClass('shipperLine',count)"
          >
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly || !elementDict.shipper.writable"
              :no="'shipperLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.consignee.viewable" slot="consignee">
          <el-form-item :label="$t('SeaExport.Consignee')" class="auto-width" :class="variableCss.consigneeCode">
            <template slot="label">
              <line-label :class="(elementDict.consignee.isRequire ? 'blue' : '') + variableCss.consigneeLine" :label="elementDict.consignee.label" />
              <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="10"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="11"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
              />
              <el-button no="12" type="primary" :disabled="readonly || !elementDict.consignee.writable" style="margin-left: 5px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            :class="'auto-width ' + getClass('consigneeLine',count)"
          >
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly || !elementDict.consignee.writable"
              :no="'consigneeLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.notify.viewable" slot="notify">
          <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width" :class="variableCss.notifyCode">
            <template slot="label">
              <line-label :class="(elementDict.notify.isRequire ? 'blue ' : ' ') + variableCss.notifyLine" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="13"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="14"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
              />
              <div style="margin-top: 5px">
                <el-button no="15" type="primary" :disabled="readonly || !elementDict.notify.writable" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-button no="16" type="primary" :disabled="readonly || !elementDict.notify.writable" style="margin-left: 5px" @click="pm.onCopyConsignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            :class="'auto-width ' + getClass('notifyLine',count)"
          >
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly || !elementDict.notify.writable"
              :no="'notifyLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item label="ALSO NOTIFY" class=" auto-width" />
          <el-form-item class=" auto-width">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="17"
              :disabled="readonly || !elementDict.notify.writable"
              wrap-symbol="r"
              :text-chars="0"
              auto-half-word
              auto-uppercase
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.payment.viewable" slot="payment">
          <el-form-item
            v-if="job.paymentTermMBL === '3P'"
            class="auto-width"
            style="padding-top: 5px"
          >
            <line-label slot="label" :class="elementDict.payment.isRequire ? 'blue' : ''" :label="elementDict.payment.label" />
            <div style="display: flex;width: 100%">
              <el-input
                v-model="form.paymentCode"
                :disabled="readonly || !elementDict.payment.writable"
                no="paymentCode"
                style="flex:1"
              />
              <el-button
                no="BringInDat"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || !elementDict.payment.writable"
                @click="pm.paymentImportData(true)"
              >{{ $t('CargoMsg.Cargo_BringInData') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            v-if="job.paymentTermMBL === '3P'"
            :key="'paymentLine'+count"
            class="auto-width"
          >
            <cargo-input
              :ref="'paymentLine'+count"
              v-model="form['paymentLine'+count]"
              :disabled="readonly || !elementDict.payment.writable"
              :no="'paymentLine'+count"
              :auto-uppercase="isUppercase"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine'+count,count+1 > 6 ? null :'paymentLine'+(count+1),0)"
            />
          </el-form-item>
        </template>
      </template>
      <template v-if="form.showDetail">
        <el-form-item slot="detailFormat" style="display: flex; justify-content: flex-end;margin-top: -24px;">
          <el-button no="GeneralFormat" :disabled="readonly" type="primary" @click="formatChange(false)">{{ $t('CargoMsg.Cargo_GeneralFormat') }} </el-button>
        </el-form-item>
        <!--  发货人 -->
        <template v-if="elementDict.shipper.viewable" slot="shipper">
          <el-form-item
            class="auto-width"
            :class="variableCss.shipperCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.shipper.isRequire ? 'blue ' : ' ') + variableCss.shipperLine" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="7"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="8"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p, true)}"
              />
              <el-button no="9" type="primary" :disabled="readonly || !elementDict.shipper.writable" style="margin-left: 5px" @click="pm.onClear(1, true)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine1"
              no="shipperLine1"
              :disabled="readonly || !elementDict.shipper.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine1','shipperLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine2"
              no="shipperLine2"
              :disabled="readonly || !elementDict.shipper.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine2','shipperLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine3"
              no="shipperLine3"
              :disabled="readonly || !elementDict.shipper.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine3','shipperLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            style="margin-bottom: -10px"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperCountry"
                no="shipperCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperCity"
                  no="shipperCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperProvince"
                no="shipperProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperZipCode"
                  no="shipperZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperMobile"
                no="shipperMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperEmail"
                  no="shipperEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.shipperContact"
                no="shipperContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.shipperFax"
                  no="shipperFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <!-- 收货人 -->
        <template v-if="elementDict.consignee.viewable" slot="consignee">
          <el-form-item
            class="auto-width"
            :class="variableCss.consigneeCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.consignee.isRequire ? 'blue ' : ' ') + variableCss.consigneeLine" :label="elementDict.consignee.label" />
              <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="10"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="11"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p, true)}"
              />
              <el-button no="12" type="primary" :disabled="readonly || !elementDict.consignee.writable" style="margin-left: 5px" @click="pm.onClear(2, true)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine1"
              no="consigneeLine1"
              :disabled="readonly || !elementDict.consignee.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine1','consigneeLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine2"
              no="consigneeLine2"
              :disabled="readonly || !elementDict.consignee.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine2','consigneeLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine3"
              no="consigneeLine3"
              :disabled="readonly || !elementDict.consignee.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine3','consigneeLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeCountry"
                no="consigneeCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeCity"
                  no="consigneeCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeProvince"
                no="consigneeProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeZipCode"
                  no="consigneeZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeMobile"
                no="consigneeMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeEmail"
                  no="consigneeEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.consigneeContact"
                no="consigneeContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.consigneeFax"
                  no="consigneeFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <!-- 通知人 -->
        <template v-if="elementDict.notify.viewable" slot="notify">
          <el-form-item
            class="auto-width"
            :class="variableCss.notifyCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.notify.isRequire ? 'blue ' : ' ') + variableCss.notifyLine" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="13"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="14"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p, true)}"
              />
              <div style="margin-top: 5px">
                <el-button no="15" type="primary" :disabled="readonly || !elementDict.notify.writable" @click="pm.onClear(3, true)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-button no="16" type="primary" :disabled="readonly || !elementDict.notify.writable" style="margin-left: 5px" @click="pm.onCopyConsignee(true)">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine1"
              no="notifyLine1"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine1','notifyLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine2"
              no="notifyLine2"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine2','notifyLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine3"
              no="notifyLine3"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine3','notifyLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyCountry"
                no="notifyCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyCity"
                  no="notifyCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyProvince"
                no="notifyProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyZipCode"
                  no="notifyZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyMobile"
                no="notifyMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyEmail"
                  no="notifyEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.notifyContact"
                no="notifyContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.notifyFax"
                  no="notifyFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <!-- ALSO NOTIFY -->
          <el-form-item class="auto-width" label="ALSO NOTIFY" />
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line1"
              no="alsoNotifyLine1"
              :disabled="readonly || !elementDict.alsoNotify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line2"
              no="alsoNotifyLine2"
              :disabled="readonly || !elementDict.alsoNotify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line3"
              no="alsoNotifyLine3"
              :disabled="readonly || !elementDict.alsoNotify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyCountry"
                no="alsoNotifyCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.alsoNotify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyCity"
                  no="alsoNotifyCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.alsoNotify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyProvince"
                no="alsoNotifyProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.alsoNotify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyZipCode"
                  no="alsoNotifyZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.alsoNotify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyMobile"
                no="alsoNotifyMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.alsoNotify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyEmail"
                  no="alsoNotifyEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.alsoNotify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.alsoNotifyContact"
                no="alsoNotifyContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.alsoNotify.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.alsoNotifyFax"
                  no="alsoNotifyFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.alsoNotify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <!--          付款方-->
        <div v-if="elementDict.payment.viewable && job.paymentTermMBL === '3P'" slot="payment">
          <el-form-item
            class="auto-width"
          >
            <line-label slot="label" :class="elementDict.payment.isRequire ? 'blue' : ''" :label="elementDict.payment.label" />
            <div style="display: flex;width: 100%">
              <el-input
                v-model="form.paymentCode"
                no="paymentCode"
                :disabled="readonly || !elementDict.payment.writable"
                style="flex:1"
              />
              <el-button
                no="BringInData"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || !elementDict.payment.writable"
                @click="pm.paymentImportData(false)"
              >{{ $t('CargoMsg.Cargo_BringInData') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine1"
              no="paymentLine1"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine2"
              no="paymentLine2"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine2','paymentLine3',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine3"
              no="paymentLine3"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine3','paymentLine4',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentCountry"
                no="paymentCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentCity"
                  no="paymentCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentProvince"
                no="paymentProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentPostalCode"
                  no="paymentPostalCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentPhone"
                no="paymentPhone"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentEmail"
                  no="paymentEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.paymentContact"
                no="paymentContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.paymentFax"
                  no="paymentFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </template>
      <el-form-item v-if="elementDict.syncContainerInfoTotal.viewable" slot="syncContainerInfoTotal" style="display: flex; justify-content: flex-end;">
        <el-button type="primary" :disabled="readonly || !elementDict.syncContainerInfoTotal.writable" @click="syncContainerInfoDialogHandle">{{ $t('SeaExport.SyncContainerInfoTotal') }}</el-button>
      </el-form-item>
      <el-form-item v-if="elementDict.quantity.viewable" slot="quantity" :class="variableCss.quantity">
        <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
        <auto-number-input
          v-model="form.quantity"
          no="18"
          :precision="0"
          :min="0"
          :disabled="!isJydEditJobFields || readonly || !elementDict.quantity.writable"
          @change="pm.quantity_Change(form.quantity)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.viewable" slot="packing" :class="variableCss.packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="19"
          :default-value="form.packing"
          :disabled="readonly || !elementDict.packing.writable"
          @change="p => {pm.packing_Change(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity" :class="variableCss.insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="form.insideQuantity"
          :disabled="readonly || !elementDict.insideQuantity.writable"
          no="20"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking" :class="variableCss.insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="21"
          :default-value="form.insidePacking"
          :disabled="readonly || !elementDict.insidePacking.writable"
          @change="p => {form.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.weight.viewable" slot="weight" :class="variableCss.weight">
        <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.weight"
            no="22"
            :precision="3"
            :min="0"
            :controls="false"
            :disabled="!isJydEditJobFields || readonly || !elementDict.weight.writable"
            style="flex: 1"
            @change="p=>{pm.calculateChargeWeight();}"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubage.viewable" slot="cubage" :class="variableCss.cubage">
        <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.cubage"
            no="23"
            :precision="3"
            :min="0"
            :controls="false"
            :disabled="!isJydEditJobFields || readonly || !elementDict.cubage.writable"
            style="flex: 1"
            @change="p=>{pm.calculateChargeWeight();}"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.viewable" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.chargeWeight"
            :disabled="readonly || !elementDict.chargeWeight.writable"
            no="24"
            :precision="3"
            :min="0"
            :controls="false"
            style="flex: 1"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName" :class="'auto-width '+variableCss.cargoEnglishName">
        <div style="display: flex;justify-content: flex-end">
          <el-button v-if="job.typeMBL===BillType.MERGE_BILL_TYPE.code" no="25" type="primary" :disabled="readonly || !elementDict.cargoEnglishName.writable" @click="pm.getCargoEnglishNameFromMergeJob()">{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob') }}</el-button>
        </div>
      </el-form-item>
      <el-form-item
        v-show="elementDict.cargoEnglishName.viewable"
        slot="cargoEnglishName"
        class="auto-width"
        :class="variableCss.cargoEnglishName"
      >
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <cargo-rich-textarea
          ref="cargoTextarea1"
          v-model="form.cargoEnglishName"
          :show-count="true"
          no="26"
          :warning-count="seMarkWarningColor"
          :text-chars="seMarkMaxChars"
          wrap-symbol="r"
          :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
          :auto-uppercase="isUppercaseByConfig"
          auto-half-word
          style="height: 110px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig, {
            warningCount: seMarkWarningColor,
            maxChar: seMarkMaxChars,autoHalfWord: true,autoUppercase:isUppercaseByConfig
          })"
        />
      </el-form-item>
      <template v-if="elementDict.mark.viewable" slot="mark">
        <el-form-item :class="'auto-width '+variableCss.mark">
          <div style="display: flex;justify-content: flex-end">
            <el-button v-if="job.typeMBL===BillType.MERGE_BILL_TYPE.code" no="27" type="primary" :disabled="readonly || !elementDict.mark.writable" @click="pm.getMarkFromMergeJob()">{{ $t('SeaExport.CopyMarkFromMergeJob') }}</el-button>
          </div>
        </el-form-item>
      </template>
      <el-form-item v-show="elementDict.mark.viewable" slot="mark" :class="'auto-width '+variableCss.mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <cargo-rich-textarea
          ref="cargoTextarea2"
          v-model="form.mark"
          :show-count="true"
          no="28"
          :warning-count="seMarkWarningColor"
          :text-chars="seMarkMaxChars"
          :disabled="!isEdit || !elementDict.mark.writable"
          wrap-symbol="r"
          :auto-uppercase="isUppercaseByConfig"
          auto-half-word
          style="height: 110px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig , {
            warningCount: seMarkWarningColor,
            maxChar: seMarkMaxChars,autoHalfWord: true,autoUppercase:isUppercaseByConfig
          })"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.quantitySum.viewable" slot="quantitySum" class="auto-width">
        <line-label slot="label" :class="elementDict.quantitySum.isRequire ? 'blue' : ''" :label="elementDict.quantitySum.label" />
        <el-input v-model="form.quantitySum" :disabled="true" no="56" />
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
        <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
        <el-input
          v-model="form.hsCode"
          no="hsCode"
          type="textarea"
          :rows="5"
          :disabled="readonly || !elementDict.hsCode.writable"
          @dblclick.native="showAdvanceTextDialog(elementDict.hsCode.label,form.hsCode,val=>{form.hsCode=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mblNbr2.viewable" slot="mblNbr2">
        <line-label slot="label" :class="elementDict.mblNbr2.isRequire ? 'blue' : ''" :label="elementDict.mblNbr2.label" />
        <el-input v-model="form.mblNbr2" no="29" :disabled="readonly || !elementDict.mblNbr2.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.hblNbr2.viewable" slot="hblNbr2">
        <line-label slot="label" :class="elementDict.hblNbr2.isRequire ? 'blue' : ''" :label="elementDict.hblNbr2.label" />
        <el-input :disabled="true" :value="form.hblNbr2" no="52" />
      </el-form-item>
      <el-form-item v-if="elementDict.txtFirstVesselVoyage.viewable" slot="txtFirstVesselVoyage">
        <line-label slot="label" :class="elementDict.txtFirstVesselVoyage.isRequire ? 'blue' : ''" :label="elementDict.txtFirstVesselVoyage.label" />
        <el-input :disabled="true" :value="txtFirstVesselVoyage" no="53" />
      </el-form-item>
      <el-form-item v-if="elementDict.sailingDate.viewable" slot="sailingDate">
        <line-label slot="label" :class="elementDict.sailingDate.isRequire ? 'blue' : ''" :label="elementDict.sailingDate.label" />
        <el-input :disabled="true" :value="sailingDate" no="54" />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode" :class="variableCss.dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dispatchingPlaceCode||''"
          tag-name="englishName"
          no="55"
          @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
        />
        <el-input v-model="form.dispatchingPlace" no="30" :disabled="readonly || !elementDict.dispatchingPlaceCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.viewable" slot="loadingPortCode" :class="variableCss.loadingPort">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.loadingPortCode||''"
          tag-name="englishName"
          no="loadingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
        />
        <el-input v-model="form.loadingPort" no="31" :disabled="readonly || !elementDict.loadingPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode" :class="variableCss.dischargingPort">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode||''"
          tag-name="englishName"
          no="dischargingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
        />
        <el-input v-model="form.dischargingPort" no="32" :disabled="readonly || !elementDict.dischargingPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode" :class="variableCss.destinationPort">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode||''"
          tag-name="englishName"
          no="destinationPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
        />
        <el-input v-model="form.destinationPort" no="33" :disabled="readonly || !elementDict.destinationPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input v-model="form.destinationPlace" no="34" :disabled="readonly || !elementDict.destinationPlace.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTerm.viewable" slot="paymentTerm">
        <line-label slot="label" :class="elementDict.paymentTerm.isRequire ? 'blue' : ''" :label="elementDict.paymentTerm.label" />
        <el-input
          no="35"
          :disabled="readonly || !elementDict.paymentTerm.writable"
          :value="ColumnUtils.paymentTermLabelFunc(form.paymentTerm)"
          @input="val=>{form.paymentTerm=val}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentPlaceBL.viewable" slot="paymentPlaceBL">
        <line-label slot="label" :class="elementDict.paymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.paymentPlaceBL.label" />
        <el-input :disabled="true" :value="form.paymentPlaceBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.viewable" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <el-input :disabled="true" :value="job.freightTerm" />
      </el-form-item>
      <el-form-item v-if="elementDict.blNumber.viewable" slot="blNumber" :class="variableCss.BLNumber">
        <line-label slot="label" :class="elementDict.blNumber.isRequire ? 'blue' : ''" :label="elementDict.blNumber.label" />
        <el-input v-model="form.blNumber" no="36" :class="variableCss.BLNumber" :disabled="readonly || !elementDict.blNumber.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signPlaceBL.viewable" slot="signPlaceBL">
        <line-label slot="label" :class="elementDict.signPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.signPlaceBL.label" />
        <el-input v-model="form.signPlaceBL" no="37" :disabled="readonly || !elementDict.signPlaceBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signDateBL.viewable" slot="signDateBL">
        <line-label slot="label" :class="elementDict.signDateBL.isRequire ? 'blue' : ''" :label="elementDict.signDateBL.label" />
        <el-date-picker v-model="form.signDateBL" no="38" style="width: 100%" type="date" value-format="yyyy-MM-dd" :disabled="readonly || !elementDict.signDateBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks" :class="variableCss.remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <cargo-rich-textarea
          v-model="form.remarks"
          no="39"
          :disabled="readonly || !elementDict.remarks.writable"
          :text-chars="0"
          wrap-symbol="r"
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val},true, {
            warningCount: 45,
            maxChar: 0
          })"
        />
      </el-form-item>
      <el-form-item
        v-if="job.typeMBL===BillType.SPLIT_BILL_TYPE.code"
        slot="orderBusinessAssociation"
        label-width="0"
        class="auto-width"
      >
        <cargo-ag-grid
          key="splitOrder"
          no="40"
          :grid-options="splitOrder.gridOptions"
          :column-defs="splitOrder.columnDefs"
          :row-data="splitOrderFinalRowData"
          style="width:100%;height:200px"
          @gridReady="splitOrderReady"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button no="41" type="primary" :disabled="readonly" @click="pm.onAddSplitDocEvent()">{{ $t('SeaExport.Add') }}</el-button>
            <el-button no="42" type="danger" :disabled="readonly" @click="pm.onRemoveSliptDocEvent()">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="job.typeMBL===BillType.MERGE_BILL_TYPE.code"
        slot="orderBusinessAssociation"
        label-width="0"
        class="auto-width"
      >
        <cargo-ag-grid
          key="mergeOrder"
          no="43"
          config-module="150005"
          :grid-options="mergeOrder.gridOptions"
          :column-defs="mergeOrder.columnDefs"
          :row-data="mergeOrderFinalRowData"
          style="width:100%;height:200px"
          @gridReady="params=>{mergeOrder.gridApi=params.api}"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button no="44" type="primary" :disabled="readonly" @click="pm.onJobsAdd()">{{ $t('SeaExport.Add3') }}</el-button>
            <el-button no="45" type="danger" :disabled="readonly" @click="pm.onJobsRemove()">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.releaseType.viewable" slot="releaseType">
        <line-label slot="label" :class="elementDict.releaseType.isRequire ? 'blue' : ''" :label="elementDict.releaseType.label" />
        <el-select
          no="46"
          :disabled="readonly || !elementDict.releaseType.writable"
          :value="form.releaseType||''"
          @input="val=>{form.releaseType=val}"
          @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in blModeList"
            :key="index"
            :label="item.name"
            :value="item.serialNumber"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.billingOfLadingRecord.viewable" slot="billingOfLadingRecord">
        <line-label slot="label" :class="elementDict.billingOfLadingRecord.isRequire ? 'blue' : ''" :label="elementDict.billingOfLadingRecord.label" />
        <a
          class="el-button el-button--primary el-button--mini"
          :class="isEdit?'is-disabled':''"
          style="display:inline-block;width: 100%;text-align: center;"
          no="70"
          :disabled="readonly || !elementDict.billingOfLadingRecord.writable"
          @click="isEdit?'':statusChangeHistoryDialog.visible=true"
        >……</a>
      </el-form-item>
      <el-form-item v-if="elementDict.lblCfrState.viewable" slot="lblCfrState" class="red ">
        <line-label slot="label" :class="elementDict.lblCfrState.isRequire ? 'blue' : ''" :label="elementDict.lblCfrState.label" />
        <el-input :value="lblCfrState" :disabled="true" no="57" />
      </el-form-item>
      <!-- 提单签发状态 -->
      <el-form-item v-if="elementDict.billLadingIssued.viewable" slot="billLadingIssued" class="red">
        <line-label slot="label" :class="elementDict.billLadingIssued.isRequire ? 'blue' : ''" :label="elementDict.billLadingIssued.label" />
        <el-input v-model="billLadingIssued" :disabled="true" no="58" />
      </el-form-item>
      <el-form-item v-if="elementDict.lblReleaseState.viewable" slot="lblReleaseState" class="red">
        <line-label slot="label" :class="elementDict.lblReleaseState.isRequire ? 'blue' : ''" :label="elementDict.lblReleaseState.label" />
        <el-input :disabled="true" :value="lblReleaseState" style="margin-bottom: 5px" no="59" />
        <a
          v-permission="['button_SingleRelease_singleRelease']"
          class="el-button el-button--primary el-button--mini"
          :class="btnReleasingDisabled?'is-disabled':''"
          style="float: right;margin-left:5px"
          no="60"
          @click="btnReleasingDisabled?'':pm.btnReleasingClickHandler()"
        >{{ form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing') }}</a>
        <a
          v-permission="['button_SingleRelease_getBack']"
          class="el-button el-button--primary el-button--mini"
          :class="btnGetBackDisabled?'is-disabled':''"
          style="float: right"
          no="61"
          @click="btnGetBackDisabled?'':pm.btnGetBackClickHandler()"
        >{{ form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('SeaExport.Back') }}</a>
      </el-form-item>
      <el-form-item v-if="elementDict.requestReleaseState.viewable" slot="requestReleaseState" class="red">
        <line-label slot="label" :class="elementDict.requestReleaseState.isRequire ? 'blue' : ''" :label="elementDict.requestReleaseState.label" />
        <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
        <cargo-button-container
          no="requestReleaseState"
          :disabled="btnReleasingDisabled || elementDict.requestReleaseState.writable"
          style="float:right;margin-left:5px"
          @click="pm.btnRequestReleasingClickHandler()"
        >
          <el-button v-permission="['button_M/HBL_SingleReleaseMBL']" type="primary">{{
            form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease')
          }}
          </el-button>
        </cargo-button-container>
      </el-form-item>
      <el-form-item v-if="elementDict.reviewDate.viewable" slot="reviewDate">
        <line-label slot="label" :class="elementDict.reviewDate.isRequire ? 'blue' : ''" :label="elementDict.reviewDate.label" />
        <el-date-picker
          v-model="form.reviewDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          no="62"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.releaseDate.viewable" slot="releaseDate">
        <line-label slot="label" :class="elementDict.releaseDate.isRequire ? 'blue' : ''" :label="elementDict.releaseDate.label" />
        <el-date-picker
          v-model="form.releaseDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          no="63"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.withholdDate.viewable" slot="withholdDate">
        <line-label slot="label" :class="elementDict.withholdDate.isRequire ? 'blue' : ''" :label="elementDict.withholdDate.label" />
        <el-date-picker
          v-model="form.withholdDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          no="64"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtCarrierScAc.viewable" slot="txtCarrierScAc">
        <line-label slot="label" :class="elementDict.txtCarrierScAc.isRequire ? 'blue' : ''" :label="elementDict.txtCarrierScAc.label" />
        <el-input :disabled="true" :value="job.carrierScac || txtCarrierScAc" no="65" />
      </el-form-item>
      <el-form-item v-if="elementDict.txtBookingAgentScAc.viewable" slot="txtBookingAgentScAc">
        <line-label slot="label" :class="elementDict.txtBookingAgentScAc.isRequire ? 'blue' : ''" :label="elementDict.txtBookingAgentScAc.label" />
        <el-input :disabled="true" :value="txtBookingAgentScAc" no="66" />
      </el-form-item>
      <el-form-item v-if="elementDict.seaeq.viewable" slot="seaeq">
        <line-label slot="label" :class="elementDict.seaeq.isRequire ? 'blue' : ''" :label="elementDict.seaeq.label" />
        <cargo-rich-textarea
          v-model="form.seaeq"
          no="47"
          :disabled="readonly || !elementDict.seaeq.writable"
          :text-chars="0"
          wrap-symbol="r"
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val},true, {
            warningCount: 45,
            maxChar: 0
          })"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.container.viewable" slot="container">
        <line-label slot="label" :class="elementDict.container.isRequire ? 'blue' : ''" :label="elementDict.container.label" />
        <cargo-rich-textarea
          v-model="form.container"
          no="48"
          :disabled="readonly || !elementDict.container.writable"
          :text-chars="0"
          wrap-symbol="r"
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog(elementDict.container.label,form.container,val=>{form.container=val},true, {
            warningCount: 45,
            maxChar: 0
          })"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.withholdReason.viewable" slot="withholdReason">
        <line-label slot="label" :class="elementDict.withholdReason.isRequire ? 'blue' : ''" :label="elementDict.withholdReason.label" />
        <el-input :disabled="true" :value="form.withholdReason" type="textarea" :rows="5" no="67" />
      </el-form-item>
      <el-form-item v-if="elementDict.portRequirement.viewable" slot="portRequirement">
        <line-label slot="label" :class="elementDict.portRequirement.isRequire ? 'blue' : ''" :label="elementDict.portRequirement.label" />
        <el-input v-model="form.portRequirement" :disabled="readonly || !elementDict.portRequirement.writable" no="portRequirement" type="textarea" :rows="5" />
        <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
          <i class="el-icon-paperclip" style="font-size: 16px;" />
          <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
        </div>
      </el-form-item>
      <div v-if="elementDict.billOfLadingPackingInfo.viewable && showEdiContainer && form.docType" slot="billOfLadingPackingInfo" class="section">
        <!--      <div v-if="showEdiContainer && form.docType" class="section" :style="{'min-width':job.typeMBL===BillType.MERGE_BILL_TYPE.code?'1599px':'1562px'}">-->
        <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit && elementDict.billOfLadingPackingInfo.writable" style="padding:5px 0">
            <el-button no="49" type="primary" @click="cargoDocUsageSelectedDialog.visible=true">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="50" type="primary" @click="removeContainerUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            no="51"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="ediContainerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </tab-MBL2-UICustom-layout>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
        no="advanceTextDialogTextarea"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="68" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="69"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :params="form" :job="job" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="searchBillNoDialog.selectHandler"
    />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
    <!-- 选择装箱信息弹窗 -->
    <add-cargo-doc-container-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.MBL2"
      :uuid-not-empty="true"
      :cargo-docs="job.typeMBL === BillType.SPLIT_BILL_TYPE.code ? splitOrderFinalRowData : null"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabMBL2"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog
      :visible.sync="matchHistoryDialog.visible"
      :cargo-doc-uuid="form.uuid"
    />
    <!--取装箱信息件毛体-->
    <sync-container-info-dialog
      ref="syncContainerInfoDialog"
      :visible.sync="syncContainerInfoDialog.visible"
      :change-post-func="syncContainerInfoChangeHandle"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabMBL2UICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2UICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabMBL2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import * as BillType from '@/class/cargo/model/parameters/BillType'

export default {
  name: 'TabMBL2UICustom',
  components: { tabMBL2UICustomLayout },
  extends: tabMBL2,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      ColumnUtils,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {}
    }
  },
  computed: {
    jobTypeMbl() {
      return this.job.typeMBL || BillType.NORMAL_BILL_TYPE.code
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    jobTypeMbl() {
      this.loadPageConfig()
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code ? UICustomConstants.SEA_BOOKING_MBL_SPLIT : UICustomConstants.SEA_BOOKING_MBL_MERGE
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
        const pageType = this.previewConfig.pageType
        if (pageType === UICustomConstants.SEA_BOOKING_MBL_SPLIT) {
          this.job.typeMBL = BillType.SPLIT_BILL_TYPE.code
        } else {
          this.job.typeMBL = BillType.MERGE_BILL_TYPE.code
        }
      } else {
        const pageType = this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code ? UICustomConstants.SEA_BOOKING_MBL_SPLIT : UICustomConstants.SEA_BOOKING_MBL_MERGE
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateRequire(cargoDocList) {
      for (const form of cargoDocList) {
        for (const name in this.elementDict) {
          const element = this.elementDict[name]
          if (!(element.visible && element.writable && element.isRequire)) {
            continue
          }
          if (name === 'shipper') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'consignee') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'notify') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'payment') {
            if (this.job.paymentTermMBL === '3P') {
              let paymentLine = ''
              for (let i = 1; i <= 7; ++i) {
                paymentLine += form['paymentLine' + i]
              }
              if (StrUtils.isEmpty(paymentLine)) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
              }
            }
            continue
          }
          if (name === 'dispatchingPlaceCode') {
            if (StrUtils.isEmpty(form.dispatchingPlaceCode) || StrUtils.isEmpty(form.dispatchingPlace)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'loadingPortCode') {
            if (StrUtils.isEmpty(form.loadingPortCode) || StrUtils.isEmpty(form.loadingPort)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'dischargingPortCode') {
            if (StrUtils.isEmpty(form.dischargingPortCode) || StrUtils.isEmpty(form.dischargingPort)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (name === 'destinationPortCode') {
            if (StrUtils.isEmpty(form.destinationPortCode) || StrUtils.isEmpty(form.destinationPort)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL2')
            }
            continue
          }
          if (element.fieldNames && element.fieldNames.length > 0) {
            for (const key of element.fieldNames) {
              const field = this.fieldDict[key]
              const label = element.fieldNames.length > 1 ? field.label : element.label
              if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabMBL2')
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
